import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import {translate} from '../../helpers/base';
import CsvExport from './CsvExport';
import clsx from 'clsx';

const Header = () => {

    const { filteredResults, selectedFilters, setIsSortOverlayVisible, setIsDistanceOverlayVisible, showMap, handleToggleMap } = useContext(AppContext);

    const searchParams = new URLSearchParams(window.location.search);
    const showCsvExport = searchParams.has('showCsvExport');

    const distance = selectedFilters.distance ? Number(selectedFilters.distance) : 20;
    const showDistanceButton = selectedFilters.lat && selectedFilters.lng;

    const handleSortButtonClick = () => {
        setIsSortOverlayVisible(true);
    };

    const handleMapButtonClick = () => {
        handleToggleMap();
    };

    const handleDistanceButtonClick = () => {
        setIsDistanceOverlayVisible(true);
    };

    return (
        <>
            <span>{translate('accommodation-overview.results.header', {count: filteredResults.length})}</span>
            <div className="accommodation-overview--results-btns">
                {showDistanceButton && <label className="btn btn-text btn-sm accommodation-overview--results-btns--distance" onClick={handleDistanceButtonClick}>
                    <span><span>{translate('accommodation-overview.results.distance.label')} </span>{distance} km</span>
                    <i className="icon icon--map-marker-radius">
                        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.9412 19.9918C26.7572 20.832 28.5294 22.0529 28.5294 23.4118C28.5294 25.9458 22.3667 28 14.7647 28C7.16267 28 1 25.9458 1 23.4118C1 22.0529 2.77221 20.832 5.58824 19.9918M14.7647 2C10.5241 2 7.11765 5.82353 7.11765 10.5647C7.11765 15.3059 13.3743 23.4118 14.7647 23.4118C16.1551 23.4118 22.4118 15.3059 22.4118 10.5647C22.4118 5.82353 19.0053 2 14.7647 2ZM14.7647 14.2353C12.8182 14.2353 11.2888 12.5529 11.2888 10.4118C11.2888 8.27059 12.8182 6.58824 14.7647 6.58824C16.7112 6.58824 18.2406 8.27059 18.2406 10.4118C18.2406 12.5529 16.7112 14.2353 14.7647 14.2353Z" stroke="black" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </i>
                </label>}
                {!showMap && <label className="btn btn-text btn-sm accommodation-overview--results-btns--sort" onClick={handleSortButtonClick}>
                    <span>{translate('accommodation-overview.results.sort.label')}</span>
                    <i className="icon icon--diverses-sort">
                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
                            <path d="M14.0919 2.4L14.0919 15M18.3996 10.8L14.13 15L9.78422 10.8M5.9073 15L5.9073 2.4M1.59961 6.6L5.86918 2.4L10.215 6.6" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                    </i>
                </label>}
                <label className={clsx('btn btn-text btn-sm accommodation-overview--results-btns--map', showMap && 'is-active')} onClick={handleMapButtonClick}>
                    <span>{translate('accommodation-overview.results.map.label')}</span>
                    <i className="icon icon--diverses-map_marker">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40">
                            <path d="M20 2.668c-7.395 0-13.334 6.19-13.334 13.867 0 7.676 10.91 20.8 13.333 20.8 2.425 0 13.334-13.124 13.334-20.8 0-7.677-5.94-13.867-13.334-13.867Zm0 19.81c-3.395 0-6.061-2.724-6.061-6.191 0-3.467 2.666-6.19 6.06-6.19 3.394 0 6.061 2.723 6.061 6.19 0 3.467-2.667 6.19-6.06 6.19Z" stroke="black" stroke-width="2" stroke-linecap="round"></path>
                        </svg>
                    </i>
                </label>
                {showCsvExport && <CsvExport />}
            </div>
        </>
    );
};

export default Header;
